import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';

import * as yup from 'yup';

/** Filial create or update request body */
export interface FilialFormInterface {
  /** Display name */
  name: string;
  /** Color (for interfaces) */
  color: string;
  /** Related rooms */
  rooms?: RoomFindInterface[];
}

/** Filial create or update request body - DTO schema */
export const FilialFormDto = SerdeDtoClass.create<FilialFormInterface>(CatalogDtosKeysEnum.FILIAL_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  rooms: {
    label: 'Помещения',
    optional: true,
    checkers: [CatalogCheckersEnum.ROOM_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    })) as yup.Schema<any>,
  }
});
